import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=3f960b67&scoped=true"
import script from "./coupon.vue?vue&type=script&lang=js"
export * from "./coupon.vue?vue&type=script&lang=js"
import style0 from "./coupon.vue?vue&type=style&index=0&id=3f960b67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f960b67",
  null
  
)

export default component.exports